export default {"src":"/_next/static/media/profile-powers.a9443bef.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};